export default {
  title: {
    en: 'Order subscription summary',
  },
  planName: {
    en: `
      {scentCount, plural, one {# Products} other {# Products}} / Month,
      {monthCount, plural, one {# Month} other {# Months}} Plan
    `,
  },
  currBalance: {
    en: 'Balance from your current subscription',
  },
  tax: {
    en: 'Tax',
  },
  shipping: {
    en: 'Shipping <span class="note">time and terms of delivery don\'t change</span>',
  },
  free: {
    en: 'FREE',
  },
  total: {
    en: 'Total',
  },
  estimateNote: {
    en: 'Upgrade will come into effect in <span class="date">{upgradeActivationMonth}</span>.',
  },
  nextChargeNote: {
    en: 'Next charge will be in <span class="date">{nextChargeMonth}</span>.',
  },
  attention: {
    en: `
      Plans automatically renew. You may cancel your automatic subscription renewal any time<br />
      <strong>Note:</strong> we will charge your card as soon as you hit Confirm
    `,
  },
  noteTitle: {
    en: 'You are upgrading for a plan:',
  },
  planNameDetailed: {
    en: `
      {scentCount, plural, one {# item} other {# items}} / shipment,
      {monthCount, plural, one {# shipment} other {# shipments}}
    `,
  },

  currBalanceDetailed: {
    en: 'Current account balance',
  },
  estimateNoteDetailed: {
    en: 'Upgraded shipment will be in <span class="date bold">{upgradeActivationMonth}</span>',
  },
  nextChargeNoteDetailed: {
    en: 'Next charge {totalPriceValue} will be in <span class="date bold">{nextChargeMonth}</span>',
  },
  attentionDetailed: {
    en: 'Renews automatically at {totalPriceValue} per {monthCount, plural, one {# month} other {# months}}. Cancel Anytime.',
  },
  noteProducts: {
    en: '{scentCount, plural, one {# product} other {# products}} per shipment',
  },
  noteMonths: {
    en: 'Shipment every {shippingPeriod, plural, one {# month} other {# months}}',
  },
  noteShipments: {
    en: 'Your prepay for {productCount, plural, one {# shipment} other {# shipments}}',
  },
  chargeNote: {
    en: 'You will be charged {priceValue} <br class="mobile" /> as soon as you press CONFIRM',
  },
  balanceTooltipText: {
    en: 'Your free month will be applied <br class="onlyMobile" />to your upgrade',
  },
}
